import React from 'react';

const IRCPRODUCTION = () => {
    return (
        <>
            <div className="about-us-container">
                <section className="activities-details">
           <button 
          onClick={() => window.history.back()}
          style={{
            marginBottom: '10px',
            padding: '8px 10px',
            backgroundColor: '#255fe8',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '16px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          ← Back to All Activities
        </button>
                    <div className="activity-intro">
                        <h2>OUR ACTIVITIES</h2>
                        <p>
                            All praise and thanks are due to Allaah Subhaanahu wa Ta'ala, IRC - Islamic Research Centre Education & Welfare Trust is involved in the following Social, Welfare and Charitable activities
                        </p>
                    </div>

                    {/* Women Empowerment Programs */}
                    <div className="activity-card">
                        <div className="activity-header">
                            <h3>
                                IRC PATHFINDER
                            </h3>
                        </div>
                        <div className="activity-content">
                            <p>

                                IRC conducts career guidance/counselling programs by the name of IRC PathFinder for youth and students regularly to guide them in choosing right faculties and professional courses and streams for their higher education. This has been a great source of creating awareness and enthusiasm for education amongst students (especially girls), to motivate them to pursue higher studies.
                            </p>

                            <p>
                                The IRC Career Guidance Notice Board displays notices of various exams, scholarships & advertisements of local & international job vacancies.


                            </p>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default IRCPRODUCTION;
